import { getCountries, getCountryCallingCode } from "react-phone-number-input";
import {
  getCountryName,
  getIntlLocaleTag,
  resolveLocale,
} from "@/lib/locales";
import type { CountryCode } from "@/lib/phone/countryCode";

/** Option shape for country pickers (structurally matches `ui/phone` CountryOption). */
export interface CountryOption {
  value: CountryCode;
  label: string;
  code?: string;
}

export function buildCountryOptions(locale: string): readonly CountryOption[] {
  const resolved = resolveLocale(locale);
  const sortLocale = getIntlLocaleTag(resolved);
  return getCountries()
    .map((country) => ({
      value: country,
      label: getCountryName(country, resolved),
      code: getCountryCallingCode(country),
    }))
    .sort((a, b) => a.label.localeCompare(b.label, sortLocale));
}
